import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { meApi } from '../services/api';

/**
 * Debounced search of the org user directory. Powers the "Add member"
 * picker. Returns up to 25 users matching the substring across email,
 * firstName, lastName.
 *
 * The query stays disabled until the picker is open AND the input has
 * settled for 300 ms — avoids a fan-out on every keystroke.
 */
export function useUsersSearch(query: string, enabled: boolean) {
  const [debounced, setDebounced] = useState(query);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(query), 300);
    return () => clearTimeout(t);
  }, [query]);

  return useQuery({
    queryKey: ['users', 'search', debounced],
    queryFn: () => meApi.users({ q: debounced || undefined, limit: 25 }),
    enabled: enabled,
    staleTime: 30_000,
  });
}
